// For pluralizing words - 'plural' is an optional argument for a case like 'person' vs. 'people', by default an 's' is
// appended to the 'singular' word
// Example usage:
// {{ 4 | pl('contributor') }} -> 4 contributors
export default (x, singular, plural) => x + ' ' + ((x == 1) ? singular : (plural || (singular + 's')));
